import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["src"];
import { onMounted, onUpdated, useAttrs } from 'vue';
import LazyLoad from 'vanilla-lazyload';
export default {
  __name: 'LazyImage',
  props: {
    config: {
      type: Object,
      "default": {}
    }
  },
  setup: function setup(__props) {
    var attrs = useAttrs();
    var defaultConfig = {
      src: '/img/v5/db-img-search-default.svg' // Placeholder
    };
    var props = __props;
    var config = Object.assign(defaultConfig, props.config);
    config.callback_error = function (el) {
      el.src = attrs.src || config.src;
    };
    if (!document.lazyLoadInstance) {
      document.lazyLoadInstance = new LazyLoad(config);
    }
    onMounted(function () {
      return document.lazyLoadInstance.update();
    });
    onUpdated(function () {
      return document.lazyLoadInstance.update();
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("img", _mergeProps({
        "class": "lazy",
        src: _unref(config).src
      }, _ctx.$attrs), null, 16, _hoisted_1);
    };
  }
};